// WeArePadel - main scripts

function initMobileNav() {
  const toggle = document.getElementById("mobileNavToggle");
  const nav = document.getElementById("mainNav");
  if (!toggle || !nav) return;

  toggle.addEventListener("click", () => {
    const isOpen = nav.classList.toggle("is-open");
    toggle.setAttribute("aria-expanded", String(isOpen));
  });

  nav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      nav.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
    });
  });
}

function initSlideshow(root) {
  const slides = [...root.querySelectorAll(".slide")];
  const dots = [...root.querySelectorAll(".slide-dot")];
  const prevBtn = root.querySelector(".slide-arrow-prev");
  const nextBtn = root.querySelector(".slide-arrow-next");
  if (!slides.length) return;

  let current = 0;
  let timer = null;
  const delay = 5000;

  function goTo(index) {
    slides[current].classList.remove("is-active");
    dots[current]?.classList.remove("is-active");
    current = (index + slides.length) % slides.length;
    slides[current].classList.add("is-active");
    dots[current]?.classList.add("is-active");
  }

  function next() {
    goTo(current + 1);
  }

  function prev() {
    goTo(current - 1);
  }

  function startAutoplay() {
    stopAutoplay();
    timer = setInterval(next, delay);
  }

  function stopAutoplay() {
    if (timer) clearInterval(timer);
  }

  nextBtn?.addEventListener("click", () => {
    next();
    startAutoplay();
  });

  prevBtn?.addEventListener("click", () => {
    prev();
    startAutoplay();
  });

  dots.forEach((dot, i) => {
    dot.addEventListener("click", () => {
      goTo(i);
      startAutoplay();
    });
  });

  root.addEventListener("mouseenter", stopAutoplay);
  root.addEventListener("mouseleave", startAutoplay);

  startAutoplay();
}

function initFeaturedTabs(root) {
  const tabs = [...root.querySelectorAll(".nox-tabs-products__tab")];
  const panels = [...root.querySelectorAll(".nox-tabs-products__panel")];

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.tab;
      tabs.forEach((t) => t.classList.toggle("is-active", t === tab));
      panels.forEach((p) => p.classList.toggle("is-active", p.dataset.panel === target));
    });
  });
}

function initLuxuryCarousel() {
  const track = document.getElementById("luxuryTrack");
  if (!track) return;
  const prevBtn = document.querySelector(".luxury-series__arrow--prev");
  const nextBtn = document.querySelector(".luxury-series__arrow--next");

  function scrollByCard(direction) {
    const card = track.querySelector(".luxury-series__card");
    if (!card) return;
    const gap = 16;
    track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: "smooth" });
  }

  prevBtn?.addEventListener("click", () => scrollByCard(-1));
  nextBtn?.addEventListener("click", () => scrollByCard(1));
}

function initReviewsCarousel() {
  const track = document.getElementById("reviewsTrack");
  if (!track) return;
  const prevBtn = document.querySelector(".reviews-widget__arrow--prev");
  const nextBtn = document.querySelector(".reviews-widget__arrow--next");

  function scrollByCard(direction) {
    const card = track.querySelector(".reviews-widget__card");
    if (!card) return;
    const gap = 24;
    track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: "smooth" });
  }

  prevBtn?.addEventListener("click", () => scrollByCard(-1));
  nextBtn?.addEventListener("click", () => scrollByCard(1));
}

function initProductGallery() {
  const root = document.getElementById("productGallery");
  if (!root) return;

  const images = [...root.querySelectorAll(".product-gallery__image")];
  const thumbs = [...root.querySelectorAll(".product-gallery__thumb")];
  const prevBtn = root.querySelector(".product-gallery__arrow--prev");
  const nextBtn = root.querySelector(".product-gallery__arrow--next");
  if (!images.length) return;

  let current = 0;

  function goTo(index) {
    current = (index + images.length) % images.length;
    images.forEach((img, i) => img.classList.toggle("is-active", i === current));
    thumbs.forEach((thumb, i) => thumb.classList.toggle("is-active", i === current));
  }

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => goTo(Number(thumb.dataset.index)));
  });

  prevBtn?.addEventListener("click", () => goTo(current - 1));
  nextBtn?.addEventListener("click", () => goTo(current + 1));
}

function initQuantityStepper() {
  document.querySelectorAll(".qty-stepper").forEach((stepper) => {
    const input = stepper.querySelector(".qty-stepper__input");
    if (!input) return;
    stepper.querySelectorAll(".qty-stepper__btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const min = Number(input.min) || 1;
        const current = Number(input.value) || min;
        const next = btn.dataset.action === "increase" ? current + 1 : Math.max(min, current - 1);
        input.value = next;
      });
    });
  });
}

function initProductOptions() {
  const form = document.getElementById("productForm");
  if (!form) return;

  const variantsJson = document.getElementById("productVariantsJson");
  if (!variantsJson) return;
  let variants;
  try {
    variants = JSON.parse(variantsJson.textContent);
  } catch (e) {
    return;
  }

  const variantIdInput = document.getElementById("productFormVariantId");
  const priceRow = document.getElementById("productPriceRow");
  const submitBtn = form.querySelector(".product-form__submit");
  const optionGroups = [...form.querySelectorAll(".product-form__option")];
  if (!optionGroups.length) return;

  const selected = optionGroups.map((group) => {
    const active = group.querySelector(".product-form__value.is-selected");
    return active ? active.dataset.value : null;
  });

  function formatMoney(amount) {
    return Number(amount).toLocaleString("es-GT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function findMatchingVariant() {
    return variants.find((variant) => {
      const options = [variant.option1, variant.option2, variant.option3];
      return selected.every((value, i) => value === null || options[i] === value);
    });
  }

  function updateUI() {
    const match = findMatchingVariant();
    if (!match) return;

    variantIdInput.value = match.id;

    const priceEl = priceRow?.querySelector(".product-info__price");
    if (priceEl) priceEl.textContent = `Q${formatMoney(match.price)}`;

    if (submitBtn) {
      submitBtn.disabled = !match.available;
      submitBtn.textContent = match.available ? "Agregar al carrito" : "Agotado";
    }
  }

  optionGroups.forEach((group, index) => {
    const label = group.querySelector(".product-form__option-value");
    group.querySelectorAll(".product-form__value").forEach((btn) => {
      btn.addEventListener("click", () => {
        group.querySelectorAll(".product-form__value").forEach((b) => b.classList.remove("is-selected"));
        btn.classList.add("is-selected");
        selected[index] = btn.dataset.value;
        if (label) label.textContent = btn.dataset.value;
        updateUI();
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initMobileNav();

  const slideshow = document.getElementById("heroSlideshow");
  if (slideshow) initSlideshow(slideshow);

  const featuredTabs = document.getElementById("featuredTabs");
  if (featuredTabs) initFeaturedTabs(featuredTabs);

  initLuxuryCarousel();
  initReviewsCarousel();
  initProductGallery();
  initQuantityStepper();
  initProductOptions();
});
